import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {AdditionalProps} from '../types';
import additionalsKeys from '../util/additionals-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import additionalGroupsKeys from 'modules/additional-groups/util/additional-groups-keys';
import {useNavigate} from 'react-router-dom';

export interface CreateAdditionalProps extends Omit<AdditionalProps, 'id'> {}

const useCreateAdditional = () => {
  const {create} = useInfiniteQueryHelpers();
  const queryHelpers = useQueryHelpers();
  const navigate = useNavigate();

  const onSuccess = (data: AdditionalProps) => {
    create(additionalsKeys.list(), data);
    queryHelpers.create(
      additionalGroupsKeys.additionals(data.additionalGroupId),
      data,
    );

    return navigate(
      `/menu/additional-groups/${data.additionalGroupId}/additionals`,
    );
  };

  return useApiMutation<AdditionalProps>({
    url: '/additionals',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar adicional',
    successTitle: 'Cadastrar adicional',
    successMessage: 'Adicional cadastrado com sucesso',
    onSuccess,
  });
};

export default useCreateAdditional;
